export default {"src":"/_next/static/media/Cool_small.9ac3c93a.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};